import { Toaster as Sonner, toast } from "sonner"
import { useEffect, useState } from "react"

const Toaster = ({
  ...props
}) => {
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <Sonner
      theme="light"
      className="toaster group"
      position={isMobile ? "bottom-center" : "top-right"}
      // Mobile: above bottom nav (64px) + safe area; Desktop: below header (80px)
      offset={isMobile ? "calc(72px + env(safe-area-inset-bottom, 0px))" : "80px"}
      visibleToasts={2}
      gap={8}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:rounded-xl",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
